// libs
import React from 'react';

// components
import { Stack } from '@lyearn/ui';
import Accordion from '@/components/Accordion';
// types
import { SectionRendererProps } from '@/components/Accordion/types';

import useTemplateSidebar from '../../hooks/useTemplateSidebar';
import SidebarItem from './components/SidebarItem';
import SidebarSection from './components/SidebarSection';
import { RenderSidebarItemParams, SidebarProps } from './types';
import { ACCORDION_PROPS, RENDERER_PROPS } from './utils';

const renderSidebarSection = ({ section }: SectionRendererProps) => {
  return <SidebarSection key={section.id} open={section.open} section={section} />;
};

function FeedbackTemplateSidebar(props: SidebarProps) {
  const { setSelectedTemplate, feedbackTemplate } = props;
  const { contents, onAccordionChange } = useTemplateSidebar({
    feedbackTemplate,
  });

  if (!contents) return null;

  const renderSidebarItem = ({ item }: RenderSidebarItemParams) => (
    <SidebarItem key={item.id} item={item} onClick={setSelectedTemplate} />
  );

  return (
    <Stack className="mt-32 flex-grow" direction="col">
      <Accordion
        ItemRenderer={renderSidebarItem}
        SectionRenderer={renderSidebarSection}
        accordionProps={ACCORDION_PROPS}
        contents={contents}
        rendererProps={RENDERER_PROPS}
        onAccordionChange={onAccordionChange}
      />
    </Stack>
  );
}

export default FeedbackTemplateSidebar;
